import { MatchingProfilePreviewCard } from "@/components/mentor-profile/matching-profile-preview-card";
import { DISPLAY_NAME_MAX_LENGTH } from "@/lib/mentor-profile/constants";
import { TextInput } from "@somethings-ui/web";
import { Smile } from "lucide-react";
import { WizardStepLayout } from "./wizard-step-layout";
import type { WizardStepProps } from "./types";

export function DisplayNameStep({
  draft,
  saveState,
  setField,
  embedded,
  reviewerNotes,
  onContinue,
  onBack,
}: WizardStepProps) {
  const displayName = draft.display_name ?? "";

  return (
    <WizardStepLayout
      reviewerNotes={reviewerNotes}
      embedded={embedded}
      stepIndex={2}
      icon={<Smile className="size-7" />}
      heading="What should teens call you?"
      subheading="This is the name on your profile. Most mentors go by a first name or a nickname."
      saveState={saveState}
      onBack={onBack}
      onContinue={onContinue}
      continueDisabled={displayName.trim().length === 0}
      preview={
        <MatchingProfilePreviewCard
          draft={draft}
          focus={{ region: "identity", zoom: 1.05 }}
        />
      }
    >
      <TextInput
        variant="default"
        label="Display name"
        labelClassName="mb-2 font-body text-base text-[#1f1e1d]"
        placeholder="What should teens call you?"
        maxLength={DISPLAY_NAME_MAX_LENGTH}
        value={displayName}
        onChange={(e) => setField("display_name", e.target.value)}
        inputClassName="border-[#1f1e1d] px-0"
        helperText="You can change this anytime"
        helperTextClassName="mt-2 font-mono text-xs text-[#797774]"
      />
    </WizardStepLayout>
  );
}
